/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function UsersList(state = {}, action) {
    switch (action.type) {
    case getConstants.GET_ALL_USER_SUCCESS:
        return {
            type: getConstants.GET_ALL_USER_SUCCESS,
            users: action.user.data.data,
            pagination: action.user.data.pagination,
        };
    case getConstants.GET_ALL_USER_FAILURE:
        return {
            type: getConstants.GET_ALL_USER_SUCCESS,
            message: action.message,
        };
    default:
        return state;
    }
}
